<template>
  <i-modal v-model="openImageModal.open" am-modal-edit>
    <template #header>
      {{ openImageModal.data.data.part_id + ' - ' + openImageModal.data.name }}
    </template>
    <div v-if="image && image.length > 0" am-images>
      <div v-for="(img, index) in image" :key="img.id" am-img>
        <div v-if="isAlg" class="_margin-bottom:1/2">
          <i-input v-model="img.alg" @change="setAlg(index)" />
        </div>
        <div v-if="!img.image && showUploadButton" class="_display:flex _justify-content:center _align-items:center">
          <i-button class="_margin-left:1" @click="openUpload(index)">
            Upload file
            <input v-show="false" ref="uploadFile" type="file" accept=".svg" :multiple="false" @change="updateImage" />
            <svg viewBox="0 0 12 12" am-icon="color" class="_margin-left:1/2">
              <use xlink:href="@/assets/icons.svg#clip" x="0" y="0" width="12" height="12"></use>
            </svg>
          </i-button>
        </div>
        <div>
          <div style="width:26vw; height:22.26vw" class="image-holder" :data-id="img.id" :title="img.id"
            @click="copyImgId(img.id)">
            <img v-if="img.imageBase64" :src="'data:image/svg+xml;base64, ' + img.imageBase64" am-svg-container />
            <div v-else v-html="img.image" am-svg-container />
          </div>
          <div am-buttons class="_display:flex _justify-content:end _align-items:center _margin-top:1/2">
            <a :href="downloadImage(img.image)"
              :download="`${openImageModal.data.name}-${openImageModal.side}.${img.mime}`">
              <i-button>
                Download
                <svg class="_margin-left:1/2" viewBox="0 0 16 16" am-icon="color">
                  <use xlink:href="@/assets/icons.svg#download" x="0" y="0" width="16" height="16" />
                </svg>
              </i-button>
            </a>
            <i-button v-if="($store.getters.isAdmin && isChild) || img.isNew" class="_margin-left:1"
              @click="img.isNew ? deleteImg(img, index) : delImg(img, index)">
              Delete
              <svg viewBox="0 0 24 24" am-icon="color" class="_margin-left:1/2">
                <use xlink:href="@/assets/icons.svg#delete" x="0" y="0" width="24" height="24"></use>
              </svg>
            </i-button>
            <i-button v-if="!img.isNew" class="_margin-left:1" @click="openUpload(index)">
              Edit
              <input v-show="false" ref="uploadFile" type="file" accept=".svg" :multiple="false" @change="updateImage" />
              <svg viewBox="0 0 24 24" am-icon="color" class="_margin-left:1/2">
                <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
              </svg>
            </i-button>
          </div>
        </div>
        <IAlert color="danger" class="_margin-top:1/4" v-if="index === editImagIndex && errorType[editImagIndex]">
          <template #icon>
              <IIcon name="ink-danger" />
          </template>
          You can upload only svg files
        </IAlert>
        <image-params v-if="isChild && !Array.isArray(img.params)" :image="img" />
        <image-attrs v-if="allAttrType.length > 0" :image="img" :types="allAttrType" />
      </div>
    </div>
    <div v-if="!image.length === 0 && loading" class="_display:flex _justify-content:center">
      <svg v-if="loading" class="_margin-left:1/4" viewBox="0 0 24 24" am-icon="color" :am-loading="loading">
        <use xlink:href="@/assets/icons.svg#preloader" x="0" y="0" width="24" height="24" />
        <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
      </svg>
    </div>
    <IAlert class="_margin-top:1/2" color="danger" v-if="errorType.new">
      <template #icon>
          <IIcon name="ink-danger" />
      </template>
      You can upload only svg files
    </IAlert>
    <i-card v-if="(isChild || image.length === 0) && !loading" am-upload-card class="_margin-top:1/2 _width:100%">
      <label am-upload-area>
        <div am-upload-area-text>
          Drag files to this area or <span>select from your computer</span>
        </div>
        <input type="file" title="Drag files to this area" accept=".svg" :multiple="isChild" @change="updateFileList" />
      </label>
    </i-card>
  </i-modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ImageParams from '../ImageParams.vue'
import ImageAttrs from '../ImageAttrs.vue'
import api from '@/_mixins/api'

export default {
  components: { ImageParams, ImageAttrs },
  data: () => ({
    loading: false,
    editImagIndex: null,
    image: [],
    imagesContent: {},
    showUploadButton: false,
    errorType: {}
  }),
  mixins: [api],
  computed: {
    ...mapState('parts', ['openImageModal']),
    isAlg () {
      if (this.image.find(el => el.alg)) return true
      if (this.openImageModal.data.showAlg) return true
      return false
    },
    allAttrType () {
      if (this.image && this.image.length > 0) {
        const attrsType = []
        this.image.forEach(el => {
          if (el.attrs) {
            el.attrs.forEach(attr => {
              if (!attrsType.includes(attr.type)) {
                attrsType.push(attr.type)
              }
            })
          }
        })
        if (this.openImageModal.data.all_attrs) {
          this.openImageModal.data.all_attrs.forEach(el => {
            if (!attrsType.includes(el)) {
              attrsType.push(el)
            }
          })
        }
        return attrsType.sort((a, b) => a > b ? 1 : -1)
      } else return false
    },
    isChild () {
      if (this.openImageModal.data.data.typeImage === 'children') return true
      return false
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_IMAGES', 'DEL_CHANGED_IMAGE', 'SET_CHANGED_PARTS']),
    ...mapMutations('ui', ['closeModal']),
    deleteImg (img, index) {
      this.DEL_CHANGED_IMAGE({
        subtable: this.$route.params.subtable,
        id: img.id
      })
      this.image.splice(index, 1)
    },
    setAlg (index) {
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.image[index],
        field: 'alg',
        partInfo: this.openImageModal.data
      })
    },
    openUpload (index) {
      this.editImagIndex = index
      this.$refs.uploadFile[index].click()
    },
    delImg (img, index) {
      this.SET_CHANGED_PARTS({
        subtable: this.$route.params.subtable,
        data: {
          value: {
            ...img,
            data: this.openImageModal.data
          },
          rowIndex: this.openImageModal.data.rowIndex,
          type: 'delete_image_ids',
          id: img.id
        }
      })
      this.image.splice(index, 1)
    },
    updateFileList (event) {
      const files = event.target.files
      Array.prototype.forEach.call(files, file => {
        if (file.type.includes('svg')) {
          this.errorType.new = false
          file.text().then(svgText => {
            let imageForBase64 = svgText
            if (!imageForBase64.includes('xmlns="http://www.w3.org/2000/svg"')) {
              imageForBase64 = imageForBase64.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
            }
            let id = `new_${this.openImageModal.side}_${this.openImageModal.data.type}_` +
              `${this.openImageModal.data.data.part_id}_${this.image?.length || 0}`
            if (this.$store.state.parts.changedImages?.[this.$route.params.subtable]?.[id]) {
              const lastKey = Object.keys(this.$store.state.parts.changedImages[this.$route.params.subtable]).reverse()[0]
              const keyArray = lastKey.split('_')
              id = `new_${this.openImageModal.side}_${this.openImageModal.data.type}_` +
                `${this.openImageModal.data.data.part_id}_${Number(keyArray[4]) + 1}`
            }
            this.image.push({
              isNew: true,
              image: imageForBase64,
              imageBase64: btoa(unescape(encodeURIComponent(imageForBase64))),
              id: id,
              side: this.openImageModal.side,
              mime: 'svg',
              type: this.openImageModal.data.type,
              alg: null,
              params: {},
              attrs: [],
              part_id: this.openImageModal.data.data.part_id
            })
            this.SET_CHANGED_IMAGES({
              subtable: this.$route.params.subtable,
              data: this.image[this.image.length - 1],
              field: 'image',
              partInfo: this.openImageModal.data
            })
          })
        } else this.errorType.new = true
      })
    },
    updateImage (event) {
      if (event.target.files[0].type.includes('svg') && this.editImagIndex !== null) {
        this.errorType[this.editImagIndex] = false
        event.target.files[0].text().then(svgText => {
          this.image[this.editImagIndex].image = svgText
          if (!svgText.includes('xmlns="http://www.w3.org/2000/svg"')) {
            svgText = svgText.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
          }
          this.image[this.editImagIndex].imageBase64 = btoa(unescape(encodeURIComponent(svgText)))
          this.SET_CHANGED_IMAGES({
            subtable: this.$route.params.subtable,
            data: this.image[this.editImagIndex],
            field: 'image',
            partInfo: this.openImageModal.data,
            isUpdate: true
          })
        })
      } else if (!event.target.files[0].type.includes('svg')) {
        this.errorType[this.editImagIndex] = true
      }
    },
    getImagesRequest (loadSVG) {
      const URLParams = new URLSearchParams()
      const paramsHash = {
        part_id: this.openImageModal.data.data.part_id,
        type: this.openImageModal.data.data.type,
        side: this.openImageModal.side,
        alg: this.openImageModal.data.alg
      }
      if (loadSVG) {
        paramsHash.onlyImages = 1
      } else {
        paramsHash.noImages = 1
      }
      for (const k in paramsHash) {
        paramsHash[k] && URLParams.set(k, paramsHash[k])
      }
      return this.request('GET', this.api.endpoint.loadImg + '?' + URLParams)
    },
    downloadImage (img) {
      const blob = new Blob([img], {
        type: 'image/svg'
      })
      return window.URL.createObjectURL(blob)
    },
    async getImg () {
      this.loading = true
      const response = await this.getImagesRequest(false)
      if (response) this.loading = false
      if (response.info.ok) {
        let imageResponse = response.body.part_images
        if (imageResponse && this.$store.state.parts.changedImages[this.$route.params.subtable]) {
          imageResponse.forEach(el => {
            const changedImage = this.$store.state.parts.changedImages[this.$route.params.subtable][el.id]
            if (changedImage) {
              if (changedImage.data.image) el.image = changedImage.data.image
              if (changedImage.data.alg) el.alg = changedImage.data.alg
              if (changedImage.data.params) el.params = changedImage.data.params
              if (changedImage.attrs) el.attrs = changedImage.attrs
            }
          })
          if (this.$store.state.parts.changedImages[this.$route.params.subtable]) {
            for (const key in this.$store.state.parts.changedImages[this.$route.params.subtable]) {
              const keyPart = `new_${this.openImageModal.side}_${this.openImageModal.data.type}` +
                `_${this.openImageModal.data.data.part_id}`
              if (key.includes(keyPart)) {
                imageResponse.push({
                  image: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.image,
                  alg: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.alg || null,
                  params: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.params || {},
                  attrs: this.$store.state.parts.changedImages[this.$route.params.subtable][key].attrs || [],
                  id: key,
                  isNew: true
                })
              }
            }
          }
        }
        const deletedImages = this.$store.state.parts.changedParts[this.$route.params.subtable]
          ?.[this.openImageModal.data.data.part_id]?.data.delete_image_ids
        if (imageResponse && deletedImages) {
          imageResponse = imageResponse.filter(el => {
            if (!deletedImages.includes(el.id)) return el
            else return false
          })
        }
        this.image = imageResponse
      }
    },
    async getImgContent () {
      const response = await this.getImagesRequest(true)
      if (response.info.ok) {
        const images = response.body.part_images
        images.forEach(img => {
          this.imagesContent[img.id] = img.image
        })
      }
    },
    fillImgContent () {
      if (!this.image || !this.image.length) {
        return []
      }
      this.image.forEach((el, index) => {
        if (el.image) return
        el.image = this.imagesContent[el.id]
        if (!el.image) {
          console.error('can not fill image with content, id: ' + el.id)
          return
        }
        if (!el.image.includes('xmlns="http://www.w3.org/2000/svg"')) {
          el.image = el.image.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')
        }
        this.image[index].imageBase64 = btoa(unescape(encodeURIComponent(el.image)))
      })
    },
    close () {
      this.openImageModal.open = false
    },
    copyImgId (id) {
      navigator.clipboard.writeText(id)
    }
  },
  mounted () {
    if (
      !this.openImageModal.data.data.part_id.toString().includes('copy') &&
      !this.openImageModal.data.data.part_id.toString().includes('new')
    ) {
      Promise.all([
        this.getImg(),
        this.getImgContent()
      ]).then(() => this.fillImgContent())
    } else if (
      (
        this.openImageModal.data.data.part_id.toString().includes('copy') ||
        this.openImageModal.data.data.part_id.toString().includes('new')
      ) &&
      this.$store.state.parts.changedImages[this.$route.params.subtable]
    ) {
      for (const key in this.$store.state.parts.changedImages[this.$route.params.subtable]) {
        const keyPart = `new_${this.openImageModal.side}_${this.openImageModal.data.type}` +
          `_${this.openImageModal.data.data.part_id}`
        if (key.includes(keyPart)) {
          this.image.push({
            image: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.image,
            alg: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.alg || null,
            params: this.$store.state.parts.changedImages[this.$route.params.subtable][key].data.params || {},
            attrs: this.$store.state.parts.changedImages[this.$route.params.subtable][key].attrs || [],
            id: key,
            isNew: true
          })
        }
      }
    }
    this.closeModal(this.close)
    window.imageModal = this
  },
  unmounted () {
    this.closeModal(null)
  }
}
</script>

<style lang="scss">
[am-modal-edit] {
  .modal {
    max-width: 60%;
    max-height: 90%;
    overflow: auto;
    position: relative;
  }
  .modal-header {
    position: fixed;
    width: inherit;
    max-width: inherit;
  }
  .modal-body {
    margin-top: 56px;
  }

  [am-icon-load] {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
  }

  [am-loading~="true"] {
    animation: rotate 300ms ease-in-out infinite;
  }

  [am-buttons] a:hover {
    text-decoration: none;
  }

  [am-images] {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    [am-img] {
      border: 1px solid var(--color--dark-40);
      width: 50%;
      padding: 1rem;
    }
  }

  [am-upload-area] {
    [am-input] {
      opacity: 0;
      position: absolute;
    }

    position: relative;
    width: 100%;

    [am-upload-area-text] {
      text-align: center;
      padding: 3rem;

      span {
        text-decoration: underline;
      }
    }

    input {
      position: absolute;
      z-index: 5;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }

  [am-upload-card]>.card-body {
    padding: 0 !important;
  }
}
</style>
